var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0109 7.23792V15.3692C28.0109 16.7504 26.8922 17.8692 25.5109 17.8692H23.1609V12.9629C23.1609 11.5817 22.0422 10.4629 20.6609 10.4629H8.21094V7.24417C8.21094 5.86292 9.32969 4.74417 10.7109 4.74417H25.5172C26.8922 4.73792 28.0109 5.85667 28.0109 7.23792Z",
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7883 17.8623V20.4561C23.7883 21.8373 22.6695 22.9561 21.2883 22.9561H12.7133L8.81953 27.2623L7.83203 22.9561H6.48828C5.10703 22.9561 3.98828 21.8373 3.98828 20.4561V12.3311C3.98828 10.9498 5.10703 9.83105 6.48828 9.83105H21.2945C22.6758 9.83105 23.7945 10.9498 23.7945 12.3311V17.8623H23.7883Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7875 15.2373H7.4375C7.09375 15.2373 6.8125 14.9561 6.8125 14.6123C6.8125 14.2686 7.09375 13.9873 7.4375 13.9873H14.7937C15.1375 13.9873 15.4187 14.2686 15.4187 14.6123C15.4187 14.9561 15.1375 15.2373 14.7875 15.2373ZM20.2313 18.6061H7.4375C7.09375 18.6061 6.8125 18.3248 6.8125 17.9811C6.8125 17.6373 7.09375 17.3561 7.4375 17.3561H20.2313C20.575 17.3561 20.8563 17.6373 20.8563 17.9811C20.8563 18.3248 20.575 18.6061 20.2313 18.6061Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.8b849c18fec41e97f560b02809f9eaa3.svg";
export { ForwardRef as ReactComponent };